module.exports = __webpack_public_path__ + "static/images/computer001.5713ad3f.jpg";